var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-container measurement-container"},[_c('div',{staticClass:"title"},[_vm._v("Dirvožemio drėgmė")]),_c('div',{staticClass:"value"},[_vm._v(" "+_vm._s(_vm.value.toFixed( 1 ))+"% ")])])}
var staticRenderFns = []

export { render, staticRenderFns }